const isRetinaDevice = (
  typeof window !== 'undefined'
  && window.devicePixelRatio >= 2
);

export {
  isRetinaDevice,
};
